import React from 'react';
import "../styles/Header.css";

function Header () {
    return (
      <div className="header">
        <h1>Employee Directory</h1>
        <p>To filter through results, simply click on a heading or begin to type in the search bar.</p>
      </div>
    )
  }

export default Header;